import { Vector3 } from '@babylonjs/core/Maths/math.vector';

export const auSampleProjectProperties = {
	desktop: {
		outdoorProject: [
			[
				{
					position: new Vector3(0.25210434198379533, 0.025802175983702047, 0.6129861080811243),
					scaling: new Vector3(4.683960479672426, 2.8952438031007706, 0.14793579053108352),
					rotation: new Vector3(-0.024084991033691456, 0.7587685851938871, 0.040030821544120784),
					cameraRadius: 5.21,
				},
				{
					position: new Vector3(0.044123888015747424, 0.19192205027529063, -2.2788778674497),
					scaling: new Vector3(4.530637139303238, 2.667945694159477, 0.2900000225072751),
					rotation: new Vector3(-0.010693960040095611, 0.7446720424316956, 0.03639366222690061),
					cameraRadius: 7.97,
				},
			],
			[
				{
					position: new Vector3(0.000010615024621074554, 0.49208898425257913, 1.922305877653327),
					scaling: new Vector3(3.7245584851588274, 2.552044915006573, 0.1479356105865628),
					rotation: new Vector3(-0.0055007334030046165, 1.5757452886313992, -0.000990775528252023),
					cameraRadius: 7.78,
				},
				{
					position: new Vector3(0.002188957529142321, 0.4919759745111135, -1.470325868766285),
					scaling: new Vector3(3.594860036978033, 2.5476296591573644, 0.2899999876009093),
					rotation: new Vector3(0.0013616621568315168, 1.5675320471152798, -0.0010019643776321772),
					cameraRadius: 7.78,
				},
			],
			[
				{
					position: new Vector3(0.025237441062927246, 0.9825357587351815, -0.2674551350010047),
					scaling: new Vector3(4.143561840057373, 2.1066436767578125, 0.14793577790260315),
					rotation: new Vector3(0, 1.5707963267948963, 0),
					cameraRadius: 6.56,
				},
			],
		],
		interiorProject: [
			[
				{
					position: new Vector3(0.013234059326350689, 0.29622238874435425, 1.4998823404312134),
					scaling: new Vector3(1.5465457357188026, 1.4586863803482133, 0.3000000049075083),
					rotation: new Vector3(-0.07135006632358003, 1.2886985091003846, -0.0012048454600481005),
					cameraRadius: 4.36,
				},
				{
					position: new Vector3(-0.2955589294433594, 0.48182210326194763, 0.33598020672798157),
					scaling: new Vector3(2.3746931633049333, 2.101308661919693, 0.2999999882178008),
					rotation: new Vector3(-0.010699203774075709, 2.7289030846839957, -0.02496797289073399),
					cameraRadius: 5.5,
				},
			],
			[
				{
					position: new Vector3(0.023786652833223343, 0.4302184581756592, 1.1515291929244995),
					scaling: new Vector3(2.1364926818436922, 1.5786622747826986, 0.2999999970536883),
					rotation: new Vector3(0.023454944608095205, 1.5757145062814308, -0.0009908979814386954),
					cameraRadius: 2.97,
				},
			],
			[
				{
					position: new Vector3(0.1126401424407959, 0.3430352509021759, -0.6037593483924866),
					scaling: new Vector3(1.2384625460672154, 1.58436918258667, 0.300000002652508),
					rotation: new Vector3(-0, 2.4772261205121806, 0),
					cameraRadius: 5.42,
				},
				{
					position: new Vector3(0.07913937419652939, 0.39723071455955505, -1.4381576776504517),
					scaling: new Vector3(1.3518696897677727, 1.798421025276184, 0.3000000451164081),
					rotation: new Vector3(0, 2.4522309204713153, 0),
					cameraRadius: 5.42,
				},
				{
					position: new Vector3(0.036581557244062424, 0.46085816621780396, -2.5080552101135254),
					scaling: new Vector3(1.5007994512494414, 2.035703182220459, 0.29999999840384434),
					rotation: new Vector3(0, 2.392800965097885, 0),
					cameraRadius: 5.42,
				},
			],
		],
	},
	mobile: {
		outdoorProject: [
			[
				{
					position: new Vector3(0.2597734034061432, 0.028962810388509924, 0.6344384816723642),
					scaling: new Vector3(4.812699035447386, 3.0340015218572334, 0.14793582351073556),
					rotation: new Vector3(-0.014999747174139105, 0.7837468312231667, 0.037450905088383946),
					cameraRadius: 5.21,
				},
				{
					position: new Vector3(0.1958752721548084, 0.1943739855703509, -2.333512459268789),
					scaling: new Vector3(4.917568782301773, 2.853121523121336, 0.2899999790724841),
					rotation: new Vector3(-0.010278485718312394, 0.7332789713180976, 0.0365132148008338),
					cameraRadius: 7.97,
				},
			],
			[
				{
					position: new Vector3(0.00014536823437083513, 0.48885880015108674, 1.9240718703514783),
					scaling: new Vector3(3.954443933018473, 2.7054639448600306, 0.14793509079526296),
					rotation: new Vector3(-0.005500714140217273, 1.5757452488151822, -0.0009907650232528508),
					cameraRadius: 7.78,
				},
				{
					position: new Vector3(0.0021813411731274714, 0.4865638703629372, -1.475289157988957),
					scaling: new Vector3(3.8128994003435874, 2.7058918997048345, 0.28999998844662667),
					rotation: new Vector3(0.0013616624462526258, 1.5675318499693753, -0.0010019650528611558),
					cameraRadius: 7.78,
				},
			],
			[
				{
					position: new Vector3(0.025237441062927246, 0.981085516862334, -0.27085028167978586),
					scaling: new Vector3(4.342493057250977, 2.264498472213745, 0.147935777),
					rotation: new Vector3(0, 1.5707963267948963, 0),
					cameraRadius: 6.56,
				},
			],
		],
		interiorProject: [
			[
				{
					position: new Vector3(0.013060279190540314, 0.30162349343299866, 1.499094843864441),
					scaling: new Vector3(1.75324426684129, 1.6224752702378036, 0.30000000217482314),
					rotation: new Vector3(-0.07135004122812706, 1.2886985217237084, -0.001204885495981053),
					cameraRadius: 4.36,
				},
				{
					position: new Vector3(-0.30163997411727905, 0.4603618383407593, 0.33306726813316345),
					scaling: new Vector3(2.5466783443009846, 2.1976786694398367, 0.30000000953540396),
					rotation: new Vector3(-0.010699200322534698, 2.7289031864655016, -0.024967957802070912),
					cameraRadius: 5.5,
				},
			],
			[
				{
					position: new Vector3(0.02381071448326111, 0.4295254945755005, 1.1597280502319336),
					scaling: new Vector3(2.360270433382115, 1.7089289537113823, 0.29999999703894303),
					rotation: new Vector3(0.023454947431757685, 1.575714473656159, -0.000990926119528065),
					cameraRadius: 2.97,
				},
			],
			[
				{
					position: new Vector3(0.08158997446298599, 0.34641650319099426, -0.6280754208564758),
					scaling: new Vector3(1.3733985428094444, 1.7252413034439087, 0.3000000051968371),
					rotation: new Vector3(-0, 2.4772261205121806, 0),
					cameraRadius: 5.42,
				},
				{
					position: new Vector3(0.06115056946873665, 0.39742299914360046, -1.4529855251312256),
					scaling: new Vector3(1.479090196472247, 1.9321552515029907, 0.29999997675106127),
					rotation: new Vector3(0, 2.4522309204713153, 0),
					cameraRadius: 5.42,
				},
				{
					position: new Vector3(0.01864555850625038, 0.44448742270469666, -2.5247254371643066),
					scaling: new Vector3(1.6039153095247722, 2.1922459602355957, 0.300000010090377),
					rotation: new Vector3(0, 2.392800965097885, 0),
					cameraRadius: 5.42,
				},
			],
		],
	},
	mobile_portrait: {
		outdoorProject: [
			[
				{
					position: new Vector3(2.0063047409057617, -0.3294594679663039, 0.255995858388718),
					scaling: new Vector3(6.502125559776202, 2.5528384709323415, 0.14793576148848073),
					rotation: new Vector3(0.025470621659846197, 0.44479737123781005, -0.01915953773230179),
					cameraRadius: 7.15,
				},
				{
					position: new Vector3(1.4652725458145142, -0.33007691656974936, -1.9110844868376677),
					scaling: new Vector3(5.445235755148926, 2.1089103289808704, 0.1479357307324618),
					rotation: new Vector3(0.02547061878105835, 0.44479762199529527, -0.019159523824356116),
					cameraRadius: 10.15,
				},
			],
			[
				{
					position: new Vector3(0.0011916487710550427, -0.08464215963085307, 1.4890849163015494),
					scaling: new Vector3(3.0709142410884605, 2.150647854179863, 0.14793577653793705),
					rotation: new Vector3(-0.005500717844375132, 1.575748057521042, -0.000990767503435116),
					cameraRadius: 14.1,
				},
				{
					position: new Vector3(0.0010251186322420835, -0.08578395340866092, -1.0506078575443651),
					scaling: new Vector3(3.0014024718921863, 2.155144433372604, 0.289999989001279),
					rotation: new Vector3(0.001361663104908753, 1.567530831057118, -0.0010019646563499186),
					cameraRadius: 14.1,
				},
			],
			[
				{
					position: new Vector3(0.025237441062927246, 0.5511736094867321, -0.8696838378804965),
					scaling: new Vector3(4.326390266418457, 2.2279000282287598, 0.28999999165534973),
					rotation: new Vector3(0, 1.5707963267948963, 0),
					cameraRadius: 12.7,
				},
			],
		],
		interiorProject: [
			[
				{
					position: new Vector3(-0.02120126038789749, 0.3583592176437378, 0.33043164014816284),
					scaling: new Vector3(1.4860138286023992, 1.3153811263565682, 0.30000000823959616),
					rotation: new Vector3(-0.07149457399609663, 1.2966265093882754, 0.018000831136491882),
					cameraRadius: 4.36,
				},
				{
					position: new Vector3(-0.009930583648383617, 0.5575634241104126, -0.7075933218002319),
					scaling: new Vector3(2.6254461470600674, 1.8328961636647896, 0.29999993660686625),
					rotation: new Vector3(-0.01750098263825143, 3.012039336541391, -0.04834776770779547),
					cameraRadius: 5.5,
				},
			],
			[
				{
					position: new Vector3(0.0251468513160944, 0.4034079611301422, 0.3874063491821289),
					scaling: new Vector3(2.26290405520924, 1.6738891722869904, 0.2999999970175126),
					rotation: new Vector3(0.02345495582089723, 1.5757144369016782, -0.0009909144589884313),
					cameraRadius: 6.1,
				},
			],
			[
				{
					position: new Vector3(0.041471339762210846, 0.5952736735343933, 0.7385839223861694),
					scaling: new Vector3(1.405061302249755, 1.6697165966033936, 0.30000001992331543),
					rotation: new Vector3(-0, 2.332344171477907, 0),
					cameraRadius: 7.32,
				},
				{
					position: new Vector3(0.04927757754921913, 0.6395522952079773, -0.04168247804045677),
					scaling: new Vector3(1.5349562741506142, 1.852447687282834, 0.3000000474835309),
					rotation: new Vector3(0, 2.332344171477907, 0),
					cameraRadius: 7.32,
				},
				{
					position: new Vector3(-0.012976708821952343, 0.6890910267829895, -1.023228645324707),
					scaling: new Vector3(1.8124174050969792, 2.056417465209961, 0.30000001791308356),
					rotation: new Vector3(0, 2.332344171477907, 0),
					cameraRadius: 7.32,
				},
			],
		],
	},
};
